<template>
  <v-dialog v-model="dialog" v-if="dialog" max-width="400px" persistent>
    <v-card flat>
      <v-card-text class="d-flex align-center justify-center pb-0" style="min-height:100px">
        <div class="text-h5 grey--text text--darken-3 pt-4 pb-4">{{cCustomNm}} 님 총 {{iGetScore}}점 획득하셨습니다.</div>
      </v-card-text>
      <v-stepper v-model="e1">
        <v-stepper-items>
          <v-stepper-content v-for="(item, n) in zWrongQues" :key="`${n + 1}-content`" :step="n + 1" class="content-center">
            <v-card flat class="">
              <v-card-text class="d-flex justify-center">
                <v-card flat>
                  <div class="text-subtitle-1 grey--text text--darken-1">{{item.id}}. {{item.cQuesData}}</div>
                  <v-radio-group v-model="item.cSelOK" readonly>
                    <v-radio value="1" :color="GetRadioColor(item,1)">
                      <template v-slot:label>
                        <div :class="GetClass(item.cOK,1)">1) {{item.cAnswer1}}</div>
                      </template>
                    </v-radio>
                    <v-radio value="2" :color="GetRadioColor(item,2)">
                      <template v-slot:label>
                        <div :class="GetClass(item.cOK,2)">2) {{item.cAnswer2}}</div>
                      </template>
                    </v-radio>
                    <v-radio value="3" :color="GetRadioColor(item,3)">
                      <template v-slot:label>
                        <div :class="GetClass(item.cOK,3)">3) {{item.cAnswer3}}</div>
                      </template>
                    </v-radio>
                    <v-radio value="4" :color="GetRadioColor(item,4)">
                      <template v-slot:label>
                        <div :class="GetClass(item.cOK,4)">4) {{item.cAnswer4}}</div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-card>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-text align="right" class="pl-0 pr-0 pb-2">
                <v-spacer></v-spacer>
                <v-btn v-if="n != 0" @click="e1 -= 1" text width="90px" class="mr-2"><v-icon class="mr-2">mdi-chevron-left</v-icon>이전</v-btn>
                <v-btn v-if="n != (zWrongQues.length-1)" @click="e1 += 1" dark width="90px" class="ml-2"><v-icon class="mr-2">mdi-chevron-right</v-icon>다음</v-btn>
                <v-btn v-if="n == (zWrongQues.length-1)" @click="dialog = false;$emit('AgainEdu')" dark width="100px" class="ml-2"><v-icon class="mr-2">refresh</v-icon>재교육</v-btn>
              </v-card-text>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>
<script>
import EventBus from '@/eventBus.js';

export default {
  components: {
  },
  data: () => ({
    dialog : false,
    cCustomNm : "",
    iGetScore : 0,
    e1: 1,
    zWrongQues: [],
  }),

  
  mounted () {
  },

  methods: {
    ShowDialog(WrongQues,CustomNm,iGetScore){
      this.dialog = true;
      this.cCustomNm = CustomNm;
      this.iGetScore = iGetScore;
      this.zWrongQues = WrongQues;
      this.e1 = 1;
      setTimeout(() => {
        EventBus.$emit("onShowMsgBox", "테스트를 통과하지 못하였습니다.", "학습후 다시 테스트에 응시해 주세요.");
      }, 10);
      
    },

    GetRadioColor(item,value){
      if (item.cSelOK != item.cOK && item.cSelOK == value) return "red"
    },

    GetClass(cOK,value){
      if (this.$store.state.CustomInfo.SiteId === 'SKMG14') {
        return ''
      }
      if (cOK == value) {
        return 'font-weight-bold'
      } else {
        return ''
      }
    },
  }
};
</script>

<style scoped>
</style>
